// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Tsb2","toggle":"styles_toggle__29egx","preview":"styles_preview__2MtPE"};